import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RichText } from 'prismic-reactjs';
import { fluidRange } from 'polished';

const Quote = ({ slice }) => {
    return (
        <SQuote>
            <SQuoteText>{RichText.render(slice.quote_text)}</SQuoteText>
            <SQuoteFooter>{slice.quote_cite}r</SQuoteFooter>
        </SQuote>
    );
};

const SQuote = styled.blockquote`
    * + &,
    & + * {
        margin-top: 60px !important;
    }
`;

const SQuoteText = styled.div`
    ${fluidRange(
        {
            prop: 'font-size',
            fromSize: '24px',
            toSize: '30px'
        },
        '320px',
        '1440px'
    )}
    display: inline;
    line-height: 1.4;
    font-style: italic;

    p::before {
        content: '“';
    }

    p::after {
        content: '”';
    }
`;

const SQuoteFooter = styled.footer`
    ${fluidRange(
        {
            prop: 'font-size',
            fromSize: '17px',
            toSize: '18px'
        },
        '320px',
        '1440px'
    )}
    margin-top: 14px;
    color: var(--color-gray-darker);
`;

export default Quote;

Quote.propTypes = {
    slice: PropTypes.object.isRequired
};
